import { CustomFieldDefinition, CustomFieldOption } from 'types/customField';

export function buildCustomFieldOptions(
  ids: string[],
  customFieldDefinition?: Pick<CustomFieldDefinition, 'options'>,
): CustomFieldOption[] {
  return (ids || []).reduce((acc, id) => {
    const option = customFieldDefinition?.options?.find(e => e.id === id);
    if (!option) {
      return acc;
    }
    return [...acc, option];
  }, [] as CustomFieldOption[]);
}
